import { colorCreatorWithDelta } from '../../utils/colorUtils';
import StyleFactory, { getNumberFromFeatureProps, getAreaLabelFromFeature, getAreaValueFromFeature, getPropFromFeature } from '../../StyleFactory';
export const themeSelector = (value, theme) => ({
  color: colorCreatorWithDelta(theme.color, value, theme.min, theme.max)
});
export default {
  grid: StyleFactory.createDefaultGridStyle(themeSelector),
  line: StyleFactory.createDefaultIsolineStyle(themeSelector),
  area: StyleFactory.createDefaultAreaStyle(themeSelector)
};